import { render, staticRenderFns } from "./RiwayatSEP.vue?vue&type=template&id=6aed572e&scoped=true&"
import script from "./RiwayatSEP.vue?vue&type=script&lang=ts&"
export * from "./RiwayatSEP.vue?vue&type=script&lang=ts&"
import style0 from "./RiwayatSEP.vue?vue&type=style&index=0&id=6aed572e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed572e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
